<template>
    <section class="carousel">
      <div class="examples">
        <picture>
          <source srcset="../img/montage1.webp" media="(min-width: 800px)">
          <source srcset="../img/montage1mini.webp" media="(max-width: 799px)">
          <img class="img" src="../img/montage1.webp" alt="пример монтажа 1">
        </picture>
        <picture>
          <source srcset="../img/montage2.webp" media="(min-width: 800px)">
          <source srcset="../img/montage2mini.webp" media="(max-width: 799px)">
          <img src="../img/montage2.webp" alt="пример монтажа 2">
        </picture>
        <picture>
          <source srcset="../img/montage3.webp" media="(min-width: 800px)">
          <source srcset="../img/montage3mini.webp" media="(max-width: 799px)">
          <img src="../img/montage3.webp" alt="пример монтажа 3">
        </picture>
        <picture>
          <source srcset="../img/montage4.webp" media="(min-width: 800px)">
          <source srcset="../img/montage4mini.webp" media="(max-width: 799px)">
          <img src="../img/montage4.webp" alt="пример монтажа 4">
        </picture>
        <picture>
          <source srcset="../img/example4.webp" media="(min-width: 800px)">
          <source srcset="../img/example4mini.webp" media="(max-width: 799px)">
          <img src="../img/example4.webp" alt="пример монтажа 5">
        </picture>
      </div>
      <div class="controls">
        <button class="left-button" @click="changeSlide('left')">
        </button>
        <button class="right-button" @click="changeSlide('right')">
        </button>
      </div>
    </section>
</template>

<script>
import {ref} from "vue";

export default {
  setup() {
    let activeSlideIndex = ref(0)
    let slidesCount = ref(5)
    function changeSlide(direction) {
      if (direction === 'right') {
        activeSlideIndex.value++
        if (activeSlideIndex.value === slidesCount.value) {
          activeSlideIndex.value = 0
        }
      } else if (direction === 'left') {
        activeSlideIndex.value--
        if (activeSlideIndex.value < 0) {
          activeSlideIndex.value = slidesCount.value - 1
        }
      }

      const img = ref(document.querySelector('.img'))
      const examples = ref(document.querySelector('.examples'))
      const width = ref(img.value.clientWidth)
      examples.value.style.transform = `translateX(-${activeSlideIndex.value * width.value}px)`
    }

    return {
      activeSlideIndex,
      slidesCount,
      changeSlide
    }
  }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

body {
  font-family: 'Roboto', sans-serif;
  height: 100vh;
}

.carousel {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  max-width: 1400px;
  height: auto;
}

.examples {
  width: 100vw;
  height: auto;
  display: flex;
  transition: transform 0.7s ease-in-out;
}

.examples picture {
  height: 100%;
  width: 100%;
}


button {
  background-color:white;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  padding: 15px;
}

img {
  margin-top: 5px;
  width: 100vw;
  max-width: 1400px;
}

button:hover {
  color: orange;
}

button:focus {
  outline: none;
}

.carousel .controls button {
  position: absolute;
  left: 35%;
  top: 80%;
  z-index: 10;
}

.carousel .controls .left-button {
  width: 40px;
  height: 40px;
  background-image: url("../img/arrowUP.png");
  background-size: contain;
  transform: translateX(300%) rotate(-90deg);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.carousel .controls .right-button {
  width: 40px;
  height: 40px;
  background-image: url("../img/arrowUP.png");
  background-size: contain;
  transform: translateX(600%) rotate(90deg);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

h1 {
  text-align: center;
  padding: 40px;
}

@media (max-width: 1200px) {
  .carousel .controls button {
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .carousel .controls button {
    left: 0;
  }
}

@media (max-width: 400px) {
  .carousel .controls button {
    top: 200px;
    left: 40px;
  }

  .carousel .controls .left-button{
    height: 20px;
    width: 20px;
  }

  .carousel .controls .right-button{
    height: 20px;
    width: 20px;
  }
}

</style>